module.exports = __webpack_public_path__ + "static/media/MedEd_Search.9753b00c.png";